import React, {useState} from 'react';
import PermissionModal from './modals/PermissionsModal';
import moment from 'moment';
import TableTdDropdown from 'components/TableTdDropdown';
import {updateUserProductType} from 'utils/api';
import {Spinner} from 'reactstrap';

const CombinedUserListItem = ({item, handleErrors, refreshList, productsList}) => {
    const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const convertDateString = (date) => {
        let stillUtc = moment.utc(date).toDate();
        return moment(stillUtc).local().format('MM/DD/YYYY hh:mm');
    };

    const openPermissionModal = (user) => {
        setIsPermissionModalOpen(true);
    };

    const handleProductChange = async(productId, productName) => {
        try {
            setSubmitting(true);
            await updateUserProductType(item.id, productId)
            refreshList(true);
            setSubmitting(false);
        } catch(err) {
            setSubmitting(false);
            handleErrors(err);
            console.log(err);
        }
    }

    return (
        <tr key={item.id} className="table_row">
            <>
                {isPermissionModalOpen && (
                    <PermissionModal
                        isOpen={isPermissionModalOpen}
                        toggle={() => setIsPermissionModalOpen(prevState => !prevState)}
                        handleErrors={handleErrors}
                        refreshList={refreshList}
                        user={item}
                    />
                )}
            </>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Organization</strong>
                <div className="table-title_container">
                    <span>{item.accountName}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Name</strong>
                <div className="table-title_container">
                    <span>{item.name}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Email</strong>
                <div className="table-title_container">
                    <span>{item.email}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Product</strong>
                <div className="table-title_container">
                    <div className="d-flex justify-content-between align-items-center">
                        {/*<span>{item.productName}</span>*/}
                        <TableTdDropdown activeValue={item.productName} options={productsList} onSelect={handleProductChange} />
                        {submitting ? <Spinner style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                            : <div style={{height: '16px', width: '16px'}}/>
                        }
                    </div>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">User Type</strong>
                <div className="table-title_container">
                    <span>{item.isAdministrator ? 'Admin' : 'User'}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Сonfirmed</strong>
                <span>
                            {item.enabled
                                ? <i style={{color: 'green'}} className="fas fa-check-circle"/>
                                : <i style={{color: '#db3c3c'}} className="fas fa-times-circle"/>
                            }
                        </span>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Created At</strong>
                {convertDateString(item.createdAt)}
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Last Login</strong>
                {item.lastLogin ? convertDateString(item.lastLogin) : ''}
            </td>
            {/*<td className="table_column" style={{verticalAlign: 'middle'}}>*/}
            {/*    <strong className="table_lable">Fetches Alerts</strong>*/}
            {/*    {item.item_alert_count}*/}
            {/*</td>*/}
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Searches Alerts</strong>
                {item.searchCount}
            </td>
            <td className="table_column column_action"
                style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Actions</strong>
                <div>
                    <i style={{cursor: 'pointer', padding: '5px'}}
                       className="fas fa-pencil-alt"
                       onClick={() => openPermissionModal(item)}/>
                </div>
            </td>
        </tr>
    );
};

export default CombinedUserListItem;
